import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { SportIconComponent } from '../sport-icon/sport-icon.component';
import { SportMenuItem } from '../sportsbook/sportsbook.models';

@Component({
  selector: 'app-sports-menu',
  standalone: true,
  imports: [CommonModule, TranslateModule, SportIconComponent],
  templateUrl: './sports-menu.component.html',
  styleUrl: './sports-menu.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SportsMenuComponent {
  readonly sports = input.required<readonly SportMenuItem[]>();
  readonly expanded = input(true);
  readonly loading = input(false);

  readonly toggleExpanded = output<void>();
  readonly sportToggle = output<number>();

  protected readonly skeletonIndexes = Array.from({ length: 7 }, (_, index) => index);
  protected readonly trackSport = (_: number, sport: SportMenuItem): number => sport.id;
}
